"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWizard = void 0;
var useWizard_1 = require("./useWizard/useWizard");
Object.defineProperty(exports, "useWizard", { enumerable: true, get: function () { return useWizard_1.useWizard; } });
//# sourceMappingURL=index.js.map